import { render, staticRenderFns } from "./IndicationLinkView.vue?vue&type=template&id=52c5d9a1"
import script from "./IndicationLinkView.vue?vue&type=script&lang=js"
export * from "./IndicationLinkView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports